import React from 'react';
import { Container, Graphics } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';

import FreeBetTitle from './freeBetTitle';
import FreeBetFooter from './freeBetFooter';
import FreeBetContent from './freeBetContent';
import FreeBetBackground from './freeBetBackground';
import { menuSectionStore } from '../../../store/menuSectionStore';

const FreeBet = observer(() => {
  if (menuSectionStore.isShowMenuPopup) {
    return null;
  }
  return (
    <Container name='FreeBetContainer'>
      {!isMobile() && (
        <Graphics
          draw={(g) => {
            g.clear();
            g.alpha = 0.7;
            g.beginFill(0x030303);
            g.drawRect(0, 0, 1440, 860);
          }}
        />
      )}
      <Container x={isMobile() ? 17 : 454} y={235}>
        <FreeBetBackground />
        <FreeBetTitle />
        <FreeBetContent />
        <FreeBetFooter />
      </Container>
    </Container>
  );
});

export default FreeBet;
